import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixel } from '../utils/metaPixel';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = entry.boundingClientRect.bottom < 0;
      setVisible(!entry.isIntersecting && passed);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-128" data-mp="2aujpaodh84kb">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-navy-100 bg-white/95 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-129" data-mp="2atgyshk2g44x">
          <div className="mx-auto flex max-w-3xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-130" data-mp="332rgzrz68abg">
            <div className="hidden sm:block" data-id="element-131" data-mp="2pa1ulmfqd3dt">
              <p className="text-[13px] font-bold text-navy-900" data-id="element-132" data-mp="2uafrc8bvsqwj">
                Ruta Clínica GLP-1™ · 6 Tomos + 5 Bonos
              </p>
              <p className="text-[12px] font-medium text-navy-700/70" data-id="element-133" data-mp="2fcnfbq5jmkn3">
                <span className="line-through" data-id="element-134" data-mp="2ke4gznvuqb4q">USD $472</span> · Hoy USD $15 ·
                Pago único
              </p>
            </div>
            <a href={CHECKOUT_URL} onClick={() => trackPixel('InitiateCheckout')} className="flex items-center justify-center gap-2 rounded-xl bg-brand px-5 py-4 text-center text-[14px] font-extrabold uppercase tracking-wide text-white shadow-lift transition-colors hover:bg-brand-dark active:scale-[0.98] sm:px-7" data-id="element-135" data-mp="26fd0jutioddf">
              Quiero la Ruta por USD $15
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-136" data-mp="34rlwtfp5rnn" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}